module.exports = __webpack_public_path__ + "img/pt_mp.8e478ca5.png";